<template>
<div class="w-100" style="overflow-x: scroll" v-dragscroll>
    <table class="w-100 border stat-table" :class="{'stats-pdf-visible': pdfVisible}">
        <thead>
            <tr>
                <td class="border"></td>
                <td v-for="(label, i) in data.labels" :key="i + '-label'" class="text-center pl-3 pr-3 border">
                    <small class="text-secondary">{{ label }}</small>
                </td>
            </tr>
            <tr v-for="(dataset, i) in data.datasets" :key="i">
                <td class="p-1 border" style="min-width: 350px">
                    <small class="text-secondary">{{ dataset.label }}</small>
                </td>
                <td v-for="(value, j) in getDatasetData(dataset)" :key="j + '-data'" class="text-center p-1 border">
                    <span v-if="canViewValue && !isValueDisabled(i)" role="button" @click="onValueClick($event, i, j)" class="btn-link">{{ value }}</span>
                    <span v-else>{{ value }}</span>
                </td>
            </tr>
        </thead>
    </table>
</div>
</template>

<script>
import {mapGetters} from "vuex";
import {ACTIVITIES} from "@/store/auth/auth";

export default {
    name: "StatisticsTable",
    props: {
        data: { type: Object, default: () => { return {} } },
        pdfVisible: { type: Boolean, default: false }
    },
    computed: {
        ...mapGetters(['isSuperuser', 'isInController', 'isMunicipalController', 'userOrganizationActivities']),
        canViewValue() {
            return this.isSuperuser || !this.isSuperuser && this.isInController
                && this.userOrganizationActivities.includes(ACTIVITIES.CONTROL) && !this.isMunicipalController;
        }
    },
    methods: {
        isValueDisabled(rowIndex) {
            return this.data.datasets[rowIndex]['disabled']
        },
        getDatasetData(dataset) {
            if (dataset.data.length === this.data.labels.length) {
                return dataset.data
            }
            let data = [...dataset.data];
            while (data.length < this.data.labels.length) {
                data.push(0)
            }
            return data
        },
        onValueClick(e, rowIndex, columnIndex) {
            if (!this.isValueDisabled(rowIndex)) {
                const rowParams = this.data.datasets[rowIndex]['rowParams'];
                let colParams = this.data.datasets[rowIndex]['colParams'];
                if (!colParams) {
                    colParams = {}
                }
                console.log(rowIndex, this.data.datasets);
                this.$emit('on-value-clicked', {rowParams: rowParams, colParams: colParams[columnIndex], filterLabel: this.data.datasets[rowIndex]['filterLabel'] })
            }
        }
    }
}
</script>

<style scoped>

</style>